import { site, footerColumns, footerNote } from "@/mocks/guaData";

const anchorMap: Record<string, string> = {
  "热点追踪": "#hot",
  "娱乐前线": "#channel",
  "综艺名场面": "#channel",
  "主播红人": "#channel",
  "话题复盘": "#timeline",
  "辟谣求真": "#channel",
  "深度专题": "#story",
  "事件复盘时间线": "#timeline",
  "热搜速览": "#hot",
  "年度盘点": "#story",
  "编辑手记": "#about",
  "关于我们": "#about",
  "常见问题": "#faq",
  "线索投稿": "#about",
  "内容转载须知": "#about",
  "联系编辑部": "#subscribe",
};

export default function Footer() {
  return (
    <footer className="border-t border-paper-300/60 bg-paper-200/50 text-stone-700">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-10 md:px-6 md:pt-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-white">
                <i className="ri-flashlight-line" />
              </span>
              <span className="font-serif text-2xl font-extrabold tracking-tight text-stone-900">{site.brand}</span>
            </a>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-stone-600">
              {site.intro} 用可查证的公开信息，把每一个刷屏话题整理成看得懂的脉络。
            </p>
            <a
              href="mailto:hello@guatiansubao.example.com"
              className="mt-4 inline-flex items-center gap-2 rounded-md bg-white px-3.5 py-2 text-sm text-stone-700 transition hover:text-primary-700"
            >
              <i className="ri-mail-line text-primary-600" />
              hello@guatiansubao.example.com
            </a>
          </div>

          {footerColumns.map((col) => (
            <nav key={col.head}>
              <h4 className="mb-3 font-serif text-base font-bold text-stone-800">{col.head}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href={anchorMap[link] || "#top"} className="group inline-flex items-center gap-1.5 text-sm text-stone-600 transition hover:text-primary-700">
                      <span className="h-px w-0 bg-primary-500 transition-all group-hover:w-3" />
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-8 border-t border-paper-300/50 pt-5">
          <p className="text-xs leading-relaxed text-stone-500">{footerNote}</p>
        </div>

        <div className="mt-5 flex flex-col items-start justify-between gap-3 border-t border-paper-300/50 pt-5 text-xs text-stone-500 sm:flex-row sm:items-center">
          <p>© {site.copyrightStart}–{new Date().getFullYear()} {site.brand} · {site.slogan}</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#about" className="whitespace-nowrap hover:text-primary-700">内容转载须知</a>
            <a href="#faq" className="whitespace-nowrap hover:text-primary-700">常见问题</a>
            <a href="#subscribe" className="whitespace-nowrap hover:text-primary-700">订阅周报</a>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-white px-3 py-1.5 text-stone-700 transition hover:text-primary-700"
            >
              <i className="ri-arrow-up-line" /> 回到顶部
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}